const GLOBAL_ACTION = {
    G_SET_USERDATA: 'G_SET_USERDATA',
    G_SET_BALANCE: 'G_SET_BALANCE',
    G_SET_PRIZERS: 'G_SET_PRIZERS',
    G_SET_RECORDS: 'G_SET_RECORDS',
    G_SET_ADDRESS: 'G_SET_ADDRESS',
    G_SET_PHONE_DRAW_RECORD_ID: 'G_SET_PHONE_DRAW_RECORD_ID',
    G_SET_CURR_PRIZE_ID: 'G_SET_CURR_PRIZE_ID',
    G_SET_PROBABILITY_LIST: 'G_SET_PROBABILITY_LIST',
    G_SET_OFFLINE: 'G_SET_OFFLINE',
    // 弹窗
    G_TRIGGER_LOGIN_MODAL: 'G_TRIGGER_LOGIN_MODAL',
    G_TRIGGER_REG_MODAL: 'G_TRIGGER_REG_MODAL',
    G_TRIGGER_MY_PRIZES_MODAL: 'G_TRIGGER_MY_PRIZES_MODAL',
    G_TRIGGER_ADDR_MODAL: 'G_TRIGGER_ADDR_MODAL',
    G_TRIGGER_UPGRADE_MODAL: 'G_TRIGGER_UPGRADE_MODAL',
    G_TRIGGER_PAY_MODAL: 'G_TRIGGER_PAY_MODAL',
    
    SHOW_OFFLINE_MODAL_VISIBLE: 'SHOW_OFFLINE_MODAL_VISIBLE',
    SET_RECEIVED_COUPON: 'SET_RECEIVED_COUPON',
    SET_SPEAKER: 'SET_SPEAKER',
    SET_SERVICE_PERIOD: 'SET_SERVICE_PERIOD',
    SET_LIFE_LONG_DATA: 'SET_LIFE_LONG_DATA',
    SET_SOUND_INVENTORY: 'SET_SOUND_INVENTORY',
    G_TRIGGER_WIN_MODAL: 'G_TRIGGER_WIN_MODAL',


    setUserData: function(userData) {
        return {
            type: GLOBAL_ACTION.G_SET_USERDATA,
            userData: userData
        }
    },
    setBalance: function(num) {
        return {
            type: GLOBAL_ACTION.G_SET_BALANCE,
            payload: num
        }
    },
    setPrizes: function(list) {
        return {
            type: GLOBAL_ACTION.G_SET_PRIZERS,
            payload: list
        }
    },
    setRecords: function(list) {
        return {
            type: GLOBAL_ACTION.G_SET_RECORDS,
            payload: list
        }
    },
    setAddress: function(addr) {
        return {
            type: GLOBAL_ACTION.G_SET_ADDRESS,
            payload: addr

        }
    },
    setPhoneDrawRecordId: function(id) {
        return {
            type: GLOBAL_ACTION.G_SET_PHONE_DRAW_RECORD_ID,
            payload: id
        }
    },
    setCurrPrizeId: function(id) {
        return {
            type: GLOBAL_ACTION.G_SET_CURR_PRIZE_ID,
            payload: id
        }
    },
    setProbabilityList: function(list) {
        return {
            type: GLOBAL_ACTION.G_SET_PROBABILITY_LIST,
            payload: list
        }
    },

    // 弹窗
    toggleLoginModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_LOGIN_MODAL,
            payload: flag
        }
    },
    toggleRegModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_REG_MODAL,
            payload: flag
        }
    },
    toggleMyPrizesModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_MY_PRIZES_MODAL,
            payload: flag
        }
    },
    toggleAddressModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_ADDR_MODAL,
            payload: flag
        }
    },
    toggleOfflineModalVisible: function(flag) {
        return {
            type: GLOBAL_ACTION.SHOW_OFFLINE_MODAL_VISIBLE,
            isOfflineModalVisible: flag
        }
    },
    setOffline: function(flag) {
        return {
            type: GLOBAL_ACTION.G_SET_OFFLINE,
            payload: flag
        }
    },
    toggleUpgradeModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_UPGRADE_MODAL,
            isUpgradeModalVisible: flag
        }
    },
    togglePayModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_PAY_MODAL,
            isPayFrameVisible: flag
        }
    },
    toggleWinModal: function(flag) {
        return {
            type: GLOBAL_ACTION.G_TRIGGER_WIN_MODAL,
            payload: flag
        }
    },

    setReceivedCoupon: function(coupon) {
        return {
            type: GLOBAL_ACTION.SET_RECEIVED_COUPON,
            receivedCoupon: coupon
        }
    },
    setSpeaker: function(speaker) {
        return {
            type: GLOBAL_ACTION.SET_SPEAKER,
            speaker: speaker
        }
    },
    setServicePeriod: function(period) {
        return {
            type: GLOBAL_ACTION.SET_SERVICE_PERIOD,
            servicePeriod: period
        }
    },
    setLifeLongData: function(data) {
        return {
            type: GLOBAL_ACTION.SET_LIFE_LONG_DATA,
            lifeLongData: data
        }
    },
    setSoundInventory: function(num) {
        return {
            type: GLOBAL_ACTION.SET_SOUND_INVENTORY,
            soundInventory: num
        }
    }
}

export default {
    ...GLOBAL_ACTION
}